module.exports = __webpack_public_path__ + "img/santo-domingo.856c9b6c.jpg";